import { get } from "./api_helper";
import moment from "moment";

// Dashboard SMS-volume chart. GET /api/messaging/me/stats/sms/timeseries
// → { series: [{ t, sent, ... }] }. Normalize to the legacy [{ Day, Count }] shape.
export const getSmsTimeseries = ({ from, to }) => {
  const qs = `from=${from}&to=${to}&bucket=day`;
  return get(`messaging/me/stats/sms/timeseries?${qs}`).then((res) =>
    (res?.series || res?.points || []).map((p) => ({
      Day: moment(p.t || p.timestamp).format("YYYY-MM-DD"),
      Count: p.sent ?? p.sms ?? 0,
    }))
  );
};

// Per-sender usage. GET /api/messaging/me/stats/snapshot → { topSenders: [...] }.
export const getSenderUsage = () =>
  get("messaging/me/stats/snapshot").then((res) =>
    (res?.topSenders || res?.sms?.topSenders || []).map((s) => ({
      name: s.sender,
      units: s.units || s.sms || 0,
    }))
  );
